module.exports = __webpack_public_path__ + "img/logo.496c6433.png";